import { parseNetworkError } from '@trello/graphql-error-handling';

import { MutationUpdateCustomFieldItemArgs } from '../generated';
import {
  QueryInfo,
  prepareDataForApolloCache,
} from '../prepareDataForApolloCache';
import { ResolverContext } from '../types';
import { token } from '@trello/session-cookie';
import { fetch } from '@trello/fetch';

export async function updateCustomFieldItem(
  obj: object,
  { idCard, idCustomField, value, idValue }: MutationUpdateCustomFieldItemArgs,
  context: ResolverContext,
  info: QueryInfo,
) {
  const response = await fetch(
    `/1/card/${idCard}/customField/${idCustomField}/item`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Trello-Client-Version': context.clientAwareness.version,
      },
      body: JSON.stringify({
        idValue,
        value,
        token: context.token || token,
      }),
    },
  );
  if (!response.ok) {
    throw await parseNetworkError(response);
  }

  const customFieldItem = await response.json();

  return prepareDataForApolloCache(customFieldItem, info);
}
